import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

@Component({
    selector: 'app-role-explanation',
    templateUrl: './role-explanation.component.html',
    styleUrls: ['./role-explanation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoleExplanationComponent implements OnInit {
  static readonly componentName = 'RoleExplanationComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { 
      roleSysText: {
        adminSysText: string; responsibleSysText: string 
      },
      actionSysText: {
        enabledSysText: string, disabledSysText: string, copySysText: string
      }
    },
    private dialogRef: MatDialogRef<RoleExplanationComponent>,
  ) { }

  ngOnInit(): void {}
}
